var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"wind-link",class:_vm.classes,attrs:{"href":_vm.hrefCoumpted,"target":_vm.target},on:{"click":_vm.onLinkClick}},[(_vm.icon)?_c('w-icon',{staticClass:"wind-link-icon",class:[_vm.iconClass],attrs:{"type":_vm.icon}}):_vm._e(),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }